export default "__VITE_ASSET__bde8cc43__"